export enum Colour {
  GREY = 4,
  RED = 3,
  ORANGE = 2,
  GREEN = 1,
  BLUE = 5
}

export enum Icon {
  EXCLAMATION = 1,
  CLOCK = 2,
  TICK = 3
}

export type BusInfo = {
  knownBus: boolean;
  tripInfo: TripInfo;
  bdcCoordinate: Coordinate;
  cpCoordinate: Coordinate;
  status: Status;
  distance?: number;
  auditingAvailable: boolean;
  cpIgnitionInput?: string;
  emvHeartbeats?: emvHeartbeatInfo[];
};

export type emvHeartbeatInfo = {
  validatorDevice: string;
  time: string;
  validatorPosition: string;
  trip: string;
  stopId: string;
  line: string;
  vehicleId: string;
  aipaServerStatus: string;
  aipaUpdateStatus: string;
  aipaMLIBStatus?: string;
  successfulTapsCount: number;
};

export type TripInfo = {
  trip: string;
  line: string;
  duty: string;
  driver: string;
  bdcTime: string;
  cpTime: string;
  vehicle: string;
  epochTime?: number;
  state?: string;
  route?: string;
};

export type Coordinate = {
  latitude: number;
  longitude: number;
  direction: number;
  color?: string;
  iconPath?: any;
  rad?: number;
};

export type Status = {
  message: string;
  symbol: Icon;
  symbolColour: Colour;
  cpColour: Colour;
  bdcColour: Colour;
  locationColour: Colour;
  emvColour?: Colour;
};

export interface GenericModel {
  [id: string]: any;
}

export interface Coords {
  lat: number;
  lng: number;
}

export interface MapModel {
  centerLat?: number;
  centerLng?: number;
  markers?: any;
  circles?: any;
  scheduledLine?: any;
  stops?: any;
}

export interface HeartbeatLocation {
  lat?: number;
  lng?: number;
  cplat?: number;
  cplng?: number;
  direction?: number;
  cpDirection?: number;
  iconPath?: any;
  time?: string;
  color?: string;
  rad?: number;
}

export interface DialogData {
  title: string;
  subtitle: string;
  status: {
    color: string;
    explanation: string;
  }[];
}
